import { Card } from "@/components/ui/card";
import { formatTRY } from "@/lib/api";
import { Wallet, CheckCircle2, Clock, Users } from "lucide-react";
import { PayrollRow } from "./PayrollRow";

export const PayrollStats = ({ data }) => {
  const stats = [
    { label: "Toplam Hakediş", value: formatTRY(data?.total_payment || 0), icon: Wallet, color: "text-emerald-600", bg: "bg-emerald-100", id: "payroll-total" },
    { label: "Ödenen", value: formatTRY(data?.paid_total || 0), icon: CheckCircle2, color: "text-indigo-600", bg: "bg-indigo-100", id: "payroll-paid" },
    { label: "Bekleyen", value: formatTRY(data?.pending_total || 0), icon: Clock, color: "text-amber-600", bg: "bg-amber-100", id: "payroll-pending" },
    { label: "Çalışan", value: data?.employee_count || 0, icon: Users, color: "text-slate-600", bg: "bg-slate-100", id: "payroll-employee-count" },
  ];
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((s) => (
        <Card key={s.id} className="p-5 border-slate-200">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-xs uppercase tracking-wider text-slate-500 font-medium">{s.label}</div>
              <div className="text-2xl font-bold text-slate-900 mt-1" style={{ fontFamily: "Outfit" }} data-testid={s.id}>{s.value}</div>
            </div>
            <div className={`h-11 w-11 rounded-xl ${s.bg} flex items-center justify-center ${s.color}`}><s.icon className="h-5 w-5" /></div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export const PayrollTable = ({ rows, expanded, onToggle, onPay, onUnpay, busy }) => (
  <Card className="border-slate-200 overflow-hidden" data-testid="payroll-table">
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-600">
          <tr>
            <th className="text-left p-4 font-medium w-8"></th>
            <th className="text-left p-4 font-medium">Çalışan</th>
            <th className="text-right p-4 font-medium">Tamamlanan İş</th>
            <th className="text-right p-4 font-medium">Toplam Hakediş</th>
            <th className="text-left p-4 font-medium">Durum</th>
            <th className="text-right p-4 font-medium">İşlem</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-200">
          {rows && rows.length === 0 && (
            <tr><td colSpan={6} className="text-center py-12 text-slate-400" data-testid="payroll-empty">Bu ay tamamlanmış iş bulunmuyor</td></tr>
          )}
          {rows?.map((row) => (
            <PayrollRow key={row.employee_id} row={row} expanded={expanded === row.employee_id}
              onToggle={() => onToggle(row.employee_id)} onPay={() => onPay(row)} onUnpay={() => onUnpay(row)}
              busy={busy === row.employee_id} />
          ))}
        </tbody>
      </table>
    </div>
  </Card>
);
